import { types } from './actions';

const initialState = {
  areShopVariablesSaving: false,
  quoteDueDateDeltaHours: undefined,
  quoteExpireDateDeltaDays: undefined,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.SHOP_VARIABLES_FETCH_SUCCESS:
      return {
        ...state,
        quoteDueDateDeltaHours: payload.quoteDueDateDeltaHours,
        quoteExpireDateDeltaDays: payload.quoteExpireDateDeltaDays,
      };
    case types.SHOP_VARIABLES_VALUES_UPDATE_ERROR:
      return {
        ...state,
        areShopVariablesSaving: false,
      };
    case types.SHOP_VARIABLES_VALUES_UPDATE_REQUEST:
      return {
        ...state,
        areShopVariablesSaving: true,
      };
    case types.SHOP_VARIABLES_VALUES_UPDATE_SUCCESS:
      return {
        ...state,
        areShopVariablesSaving: false,
        quoteDueDateDeltaHours: payload.quoteDueDateDeltaHours,
        quoteExpireDateDeltaDays: payload.quoteExpireDateDeltaDays,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.company.shopVariables;

export const areShopVariablesSaving = (state) =>
  getScope(state).areShopVariablesSaving;

export const getQuoteDueDateDeltaHours = (state) =>
  getScope(state).quoteDueDateDeltaHours;

export const getQuoteExpireDateDeltaDays = (state) =>
  getScope(state).quoteExpireDateDeltaDays;
